/**
 * MobileTeacherHero — the forest "Your week ahead" card at the top of My
 * schedule on a phone: how many workshops are left this week, the next shift,
 * and the prep it needs.
 */
import type { WorkshopChip } from '../primitives';
import { nextShiftLabel, prepLabel, remainingThisWeek } from '../teacher/my-week';

import MobileHeroStat from './components/MobileHeroStat';

interface HeroCardProps {
  /** The teacher's upcoming workshops, earliest first. */
  workshops: WorkshopChip[];
  now: Date;
}

export function HeroCard({ workshops, now }: HeroCardProps) {
  const next = workshops.find((w) => new Date(w.date) >= now);
  return (
    <section
      aria-label="Your week ahead"
      style={{
        background: 'var(--nb-forest)',
        color: '#fff',
        borderRadius: 14,
        padding: 14,
        marginBottom: 14,
      }}
    >
      <div className="nb-eyebrow" style={{ color: 'rgba(255,255,255,0.6)' }}>
        Your week ahead
      </div>
      <div
        className="nb-tabular"
        style={{ fontSize: 38, fontWeight: 700, lineHeight: 1, marginTop: 4 }}
      >
        {remainingThisWeek(workshops, now)}{' '}
        <span style={{ fontSize: 14, fontWeight: 600, opacity: 0.7 }}>workshops</span>
      </div>
      <div
        style={{
          display: 'flex',
          gap: 16,
          marginTop: 14,
          paddingTop: 12,
          borderTop: '1px solid rgba(255,255,255,0.15)',
        }}
      >
        <MobileHeroStat label="Next shift" value={nextShiftLabel(next, now)} />
        <MobileHeroStat label="Prep" value={prepLabel(next)} />
      </div>
    </section>
  );
}
